/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2517
 */

module.exports = function (e, t) {
  for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
    var a = e[n]
    if (t(a, n, e)) {
      o[i++] = a
    }
  }
  return o
}
